import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'confirmation-save',
  template: require('./confirmation.save.component.html')
})
export class ConfirmationSaveComponent {
  @Input() message: string;
  @Input() type   : string;

  remember = false;

  constructor (
    public activeModal: NgbActiveModal
  ) {}

  no () : void {
    this.activeModal.close({
      answer  : false,
      remember: this.remember
    });
  }

  yes () : void {
    this.activeModal.close({
      answer  : true,
      remember: this.remember
    });
  }
}
